const KEY = "ot_player_v1";

const uuid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now().toString(16)}-${Math.random().toString(16).slice(2)}`);

export const getPlayer = () => {
  try {
    const p = JSON.parse(localStorage.getItem(KEY) || "null");
    if (p?.id) return p;
  } catch { /* ignore */ }
  return savePlayer({ id: uuid(), name: "" });
};

export const savePlayer = (p) => {
  localStorage.setItem(KEY, JSON.stringify(p));
  return p;
};
